<script setup lang="ts">
type tAddress = {
    line1: string;
    line2: string;
    line3: string;
    line4: string;
    line5: string;
    postcode: string;
};

interface Props {
    name: string;
    dateOfBirth: string;
    address: tAddress;
    phone: string;
    email: string;
    smoker: "Non smoker" | "Smoker";
}

defineProps<Props>();
</script>

<template>
    <div class="box customer-details">
        <div class="details-col">
            <h4 class="head">Policy Holder Details</h4>
            <p class="data">{{ name }}</p>
            <p class="data">{{ dateOfBirth }}</p>
            <p class="data">{{ smoker }}</p>
        </div>
        <div class="details-col">
            <h4 class="head">Address</h4>
            <p v-if="address.line1" class="data obfuscate">
                {{ address.line1 }}
            </p>
            <p v-if="address.line2" class="data obfuscate">
                {{ address.line2 }}
            </p>
            <p v-if="address.line3" class="data obfuscate">
                {{ address.line3 }}
            </p>
            <p v-if="address.line4" class="data obfuscate">
                {{ address.line4 }}
            </p>
            <p v-if="address.line5" class="data obfuscate">
                {{ address.line5 }}
            </p>
            <p v-if="address.postcode" class="data obfuscate">
                {{ address.postcode }}
            </p>
        </div>

        <div class="details-col">
            <h4 class="head">Email Address</h4>
            <p class="data obfuscate">{{ email }}</p>
        </div>
    </div>
</template>

<style scoped>
p {
    margin: 0 0.5rem;
}

.box.customer-details {
    background: var(--pure-white);
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media screen and (width <= 768px) {
        flex-direction: column;
    }
}

.details-col {
    flex: 1;
    border: 1px solid var(--color-background-alt);
    min-width: 200px;
    padding-bottom: 1rem;

    @media screen and (width <= 768px) {
        border: none;
    }
}

.head {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: var(--off-black);
    border-bottom: 2px solid var(--off-black);
    padding: 1rem 0.5rem;
}

.data {
    font-size: 14px;
    color: var(--off-black);
}
</style>
